export default "__VITE_ASSET__BV98__3h__"